import TypeOfOrderSelector from 'components/form/TypeOfOrderSelector/styled';

export default TypeOfOrderSelector;
